import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "search",
  class: "w-full h-full max-w-4xl rounded-[2rem] border border-white/60 bg-white/90 p-4 shadow-[0_30px_80px_rgba(15,23,42,0.24)] ring-1 ring-slate-200/80 backdrop-blur sm:p-6"
}
const _hoisted_2 = { class: "flex flex-wrap gap-2" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "mt-4 flex flex-wrap gap-2" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex gap-2" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = {
  key: 0,
  class: "mt-4 overflow-hidden rounded-full bg-slate-200"
}
const _hoisted_9 = {
  key: 1,
  class: "mt-4 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm font-medium text-amber-900"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  id: "results",
  class: "mt-5 flex gap-4 overflow-x-auto pb-2"
}
const _hoisted_13 = {
  key: 3,
  class: "mt-4 flex justify-center"
}
const _hoisted_14 = { class: "rounded-full bg-slate-100 px-4 py-2 text-sm font-medium text-slate-700" }
const _hoisted_15 = {
  key: 4,
  class: "mt-3 flex justify-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_Cropper = _resolveComponent("Cropper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.apiNames, (api) => {
        return (_openBlock(), _createElementBlock("a", {
          key: api,
          href: "#",
          class: _normalizeClass(["rounded-full px-4 py-2 text-xs font-semibold uppercase tracking-[0.25em] transition", _ctx.currentApi === api ? 'bg-slate-900 text-white shadow-lg shadow-slate-900/20' : 'bg-slate-100 text-slate-500 hover:bg-slate-200 hover:text-slate-700']),
          onClick: _withModifiers(($event: any) => (_ctx.changeApi(api)), ["prevent"])
        }, _toDisplayString(api), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
        return (_openBlock(), _createElementBlock("a", {
          key: tab.value,
          href: "#",
          class: _normalizeClass(["rounded-full px-4 py-2 text-sm font-medium transition", _ctx.currentTab === tab.value ? 'bg-blue-500 text-white shadow-lg shadow-blue-500/30' : 'bg-blue-50 text-blue-700 hover:bg-blue-100']),
          onClick: _withModifiers(($event: any) => (_ctx.changeTab(tab.value)), ["prevent"])
        }, _toDisplayString(tab.label), 11, _hoisted_5))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: "mt-5 rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50/80 p-3 shadow-inner sm:p-4",
      onDragenter: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
      onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDrop && _ctx.handleDrop(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          class: "min-w-0 flex-1 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-800 shadow-sm outline-none placeholder:text-slate-400 focus:border-blue-400 focus:ring-4 focus:ring-blue-100",
          placeholder: 'Search ' + _ctx.currentTab,
          autocomplete: "off",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query) = $event)),
          type: "text",
          id: "name",
          name: "name"
        }, null, 8, _hoisted_7), [
          [_vModelText, _ctx.query]
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "flex min-h-11 shrink-0 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-700 shadow-sm hover:border-blue-300 hover:text-blue-700",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFilePicker && _ctx.openFilePicker(...args)))
        }, [
          _createVNode(_component_ion_icon, { name: "images-outline" }),
          _cache[7] || (_cache[7] = _createElementVNode("span", { class: "hidden sm:inline" }, "Upload", -1))
        ]),
        _createElementVNode("input", {
          ref: "fileInput",
          class: "hidden",
          type: "file",
          accept: "image/*",
          multiple: "",
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleFileInput && _ctx.handleFileInput(...args)))
        }, null, 544)
      ]),
      _cache[8] || (_cache[8] = _createElementVNode("p", { class: "mt-2 text-xs text-slate-500" }, "Upload images or drag them here.", -1))
    ], 32),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[9] || (_cache[9] = [
          _createElementVNode("div", { class: "h-2 w-full animate-pulse bg-gradient-to-r from-blue-400 via-sky-500 to-cyan-400" }, null, -1)
        ]))]))
      : (_ctx.warning)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _cache[10] || (_cache[10] = _createElementVNode("span", null, "This API is temporarily unavailable. Try again later or open an ", -1)),
            (_ctx.issueUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.issueUrl,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  class: "font-bold underline decoration-amber-500 underline-offset-2 hover:text-amber-700"
                }, "issue", 8, _hoisted_10))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, "issue")),
            _cache[11] || (_cache[11] = _createElementVNode("span", null, " if the error persists.", -1))
          ]))
        : (_ctx.results.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result) => {
                return (_openBlock(), _createBlock(_component_Cropper, {
                  key: result.mal_id,
                  result: result,
                  "click-action": _ctx.has_show_more && !_ctx.showing_more ? 'show-more' : 'crop',
                  onShowMore: ($event: any) => (_ctx.showMore({ tab: _ctx.currentTab, selected: result }))
                }, null, 8, ["result", "click-action", "onShowMore"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
    (_ctx.showing_more && _ctx.selected_title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.selected_title), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showing_more)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("a", {
            href: "#",
            class: "inline-flex items-center gap-2 rounded-full bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-700",
            onClick: _cache[6] || (_cache[6] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)), ["prevent"]))
          }, [
            _createVNode(_component_ion_icon, { name: "arrow-undo-outline" }),
            _cache[12] || (_cache[12] = _createElementVNode("span", null, "Back", -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}